<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div
              class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4"
            >
              <a
                class="pr-2 text-dark cursor-pointer"
                v-on:click="$router.push('/subscription-plan')"
                ><span class="font-24 mr-2"
                  ><img src="/images/back-arrow.svg" width="18"
                /></span>
              </a>
              <h4 class="mb-0 lg-bld">
                {{ uuid ? "Edit" : "Add" }} Subscription Plan
              </h4>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-2">
            <div class="row">
              <div class="col-lg-10 col-sm-10 float-none">
                <div class="card border mb-0 radius-15">
                  <div class="card-body">
                    <Form itemref="adminForm" @submit="save()">
                      <div class="row">
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Name</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="name"
                              class="form-control"
                              placeholder="Name"
                              v-model="detail.name"
                              rules="required:name"
                              autocomplete="off"
                              :validateOnInput="true"
                            />
                            <ErrorMessage name="name" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Fees (Rs)</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="fees"
                              class="form-control"
                              placeholder="Fees"
                              :disabled="uuid"
                              v-model="detail.fee"
                              rules="required:fees"
                              :validateOnInput="true"
                            />
                            <ErrorMessage name="fees" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Validity(Days)</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="validity"
                              class="form-control"
                              :disabled="uuid"
                              placeholder="Validity(Days)"
                              v-model="detail.validity_in_days"
                              rules="required:validity"
                              :validateOnInput="true"
                            />
                            <ErrorMessage name="validity" class="text-danger" />
                            <!-- <div data-toggle="modal" data-target="#changePassword" style="
                                float: right;
                                cursor: pointer;
                                text-decoration: underline;
                              " v-show="detail.uuid" v-on:click="showChangePasswordPopup">
                              <a>Change Password</a>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Contact Views</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="contact_views"
                              class="form-control"
                              :disabled="uuid"
                              placeholder="Contact Views"
                              v-model="detail.max_contact_views_count"
                              rules="required:contact views"
                              :validateOnInput="true"
                            />
                            <ErrorMessage
                              name="contact_views"
                              class="text-danger"
                            />
                            <!-- <div data-toggle="modal" data-target="#changePassword" style="
                                float: right;
                                cursor: pointer;
                                text-decoration: underline;
                              " v-show="detail.uuid" v-on:click="showChangePasswordPopup">
                              <a>Change Password</a>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-lg-12 col-sm-6">
                          <label>Description</label>
                          <editor
                            :api-key="$helperService.getkey()"
                            placeholder="Description"
                            v-model="detail.description"
                          ></editor>
                        </div>
                        <div class="col-md-6">
                          <label>Status</label>

                          <div class="custom-control custom-switch ms-5">
                            <input
                              class="custom-control-input"
                              type="checkbox"
                              id="customSwitch1"
                              :disabled="uuid"
                              true-value="ACTIVE"
                              false-value="INACTIVE"
                              v-model="detail.status"
                            />
                            <label
                              class="custom-control-label"
                              for="customSwitch1"
                            >
                            </label>
                          </div>
                        </div>

                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button" class="fill-btn px-4 ml-3">
                            Save
                          </button>
                          <button
                            type="button"
                            class="fil-btn px-4 ml-3"
                            v-on:click="$router.go(-1)"
                            id="cancel-button"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <TextModal ref="textModal">
      <div class="modal-header pt-0">
        <h5 class="modal-title">Change Password</h5>
        <button type="button" class="close" v-on:click="$refs.textModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="changePasswordForm" @submit="changePassword">
        <div class="col-lg-12 col-sm-12">
          <div class="form-group">
            <label>New Password</label>
            <span class="text-danger">*</span>
            <Field :type="passwordFieldType" name="name_password" class="form-control" placeholder="New Password"
              v-model="password" rules="required:password|minLength:6" :validateOnInput="true" />
            <span style="position: absolute; right: 22px; top: 40px; z-index: 999">
              <a class="psw-icon cursor-pointer" v-on:click="switchVisibility"><img :src="image" width="20" /></a>
            </span>
            <ErrorMessage name="name_password" class="text-danger" />
          </div>
        </div>
        <div class="col-lg-12 col-sm-12">
          <div class="form-group">
            <label>Confirm Password</label>
            <span class="text-danger">*</span>
            <Field :type="passwordFieldType2" placeholder="Confirm Password" name="name_ccpassword" class="form-control"
              rules="required:confirm password|confirmed:@name_password" :validateOnInput="true" />
            <span style="
                                position: absolute;
                                right: 20px;
                                top: 40px;
                                z-index: 999;
                              ">
              <a class="psw-icon cursor-pointer" v-on:click="switchPasswordVisibility"><img :src="images"
                  width="20" /></a>
            </span>
            <ErrorMessage name="name_ccpassword" class="text-danger" />
          </div>
        </div>
        <div class="modal-footer pb-0">
          <button class="fill-btn" id="change-password-button" style="width: 20%; border-radius: 5px">
            Save
          </button>
          <button type="button" class="fil-btn" id="cancel-button" v-on:click="$refs.textModal.closeModal"
            style="width: 20%; border-radius: 5px">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal> -->
  </div>
</template>
<script>
// import TextModal from "@/components/TextModal";
import { Form, Field, ErrorMessage } from "vee-validate";
import Editor from "@tinymce/tinymce-vue";
// import PhoneCode from "../../components/PhoneCodePicker/PhoneCode.vue";
export default {
  name: "AddSubscriptionPlan",
  components: {
    Form,
    Field,
    ErrorMessage,
    Editor,
    // TextModal,
    // PhoneCode,
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      roleList: [],
      detail: {},
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    if (this.uuid) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$api
        .getAPI({
          _action: "/subscription-plan/" + this.uuid,
        })
        .then((res) => {
          this.detail = res;
        })
        .catch(() => {});
    },
    save() {
      if (this.uuid) {
        this.$api
          .putAPI({
            _action: "/edit-subscription",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$router.go(-1);
            this.$notify({
              type: "success",
              text: res.message,
            });
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/add-subscription",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$router.go(-1);
            this.$notify({
              type: "success",
              text: res.message,
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>
